import {Routes} from '@angular/router';
import {HomePageComponent} from './home/home.component';
import {authGuard, DASHBOARD_STORAGE_KEY, dashboardStorageGuard, LANGUAGE_STORAGE_KEY, roleGuard, userPermissionGuard} from '@core/guards';
import {SsoComponent} from './sso/sso.component';
import {canDeactivateGuard} from '@core/guards/can-deactivate.guard';

const childrenRoutes: Routes = [
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'home',
    loadComponent: () => import('./welcome/welcome-page.component').then(m => m.WelcomePageComponent)
  },
  {
    path: 'manage-companies',
    canMatch: [userPermissionGuard],
    data: {permission: 'company.index'},
    canActivate: [roleGuard],
    loadComponent: () => import('./company/manage-companies/manage-companies.component').then(m => m.ManageCompaniesComponent)
  },
  {
    path: 'company',
    canMatch: [userPermissionGuard],
    data: {
      permission: 'company.view-information'
    },
    loadChildren: () => import('./company/workplace-company/workplace-company.module').then(m => m.WorkplaceCompanyModule)
  },
  {
    path: 'briefs',
    loadChildren: () => import('./briefs/briefs.module').then(m => m.BriefsModule)
  },
  {
    path: 'approvals',
    loadComponent: () => import('./approvals/approvals').then(m => m.ApprovalsComponent),
    children: [
      {
        path: '',
        redirectTo: 'my',
        pathMatch: 'full'
      },
      {
        path: 'my',
        loadComponent: () => import('./approvals/my-approvals/approvals.component').then(m => m.ApprovalsComponent),
        data: {
          page: 'my'
        }
      },
      {
        path: 'all',
        loadComponent: () => import('./approvals/all-approvals/all-approvals.component').then(m => m.AllApprovalsComponent),
        data: {
          page: 'all'
        }
      }
    ]
  },
  {
    path: 'asset-archive',
    loadChildren: () => import('./asset-archive/asset-archive.module').then(m => m.AssetArchiveModule)
  },
  {
    path: 'dashboard',
    canMatch: [dashboardStorageGuard],
    data: {
      permission: 'reports.view-reports',
      key: 'dashboardUrl',
      storageKey: DASHBOARD_STORAGE_KEY
    },
    loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent)
  },
  {
    path: 'language-dashboard',
    data: {
      key: 'selfServeUrl',
      storageKey: LANGUAGE_STORAGE_KEY
    },
    loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent)
  },
  {
    path: 'language-dashboard-beta',
    loadComponent: () => import('./language-dashboard/language-dashboard.component').then(m => m.LanguageDashboardComponent),
    children: [
      {
        path: '',
        redirectTo: 'global',
        pathMatch: 'full'
      },
      {
        path: ':region',
        loadComponent: () => import('./language-dashboard/language-table/language-table.component').then(m => m.LanguageTableComponent)
      }
    ]
  },
  {
    path: 'campaigns',
    loadChildren: () => import('./campaign/campaign.module').then(m => m.CampaignModule),
    data: {
      permission: 'campaign.index'
    }
  },
  {
    path: 'add-new-version/:briefId/:id/:type',
    loadComponent: () => import('./approval-version/approval-version.component').then(m => m.ApprovalVersionComponent)
  },
  {
    path: 'upload-approvals/:briefId/:type',
    loadComponent: () => import('./upload/upload.component').then(m => m.UploadComponent),
    canDeactivate: [canDeactivateGuard],
    children: [
      {
        path: '',
        data: {step: 1},
        loadComponent: () =>
          import('./upload/view/deliverable-type-selection/deliverable-type-selection.component').then(
            m => m.DeliverableTypeSelectionComponent
          )
      },
      {
        path: ':uploadType',
        data: {step: 2},
        loadComponent: () => import('./upload/view/upload-file/upload-file.component').then(m => m.UploadFileComponent)
      },
      {
        path: ':uploadType/settings',
        data: {step: 3},
        loadComponent: () => import('./upload/view/settings/settings.component').then(m => m.SettingsComponent)
      }
    ]
  },
  {
    path: 'notifications',
    loadComponent: () => import('./notifications/notifications.component').then(m => m.NotificationsComponent)
  }
];

export const routes: Routes = [
  {path: '', redirectTo: '/home', pathMatch: 'full'},
  {path: '', component: HomePageComponent, canActivate: [authGuard], children: childrenRoutes},
  {path: 'loginredirect', loadChildren: () => import('./login/login.module').then(m => m.OctLoginModule)},
  {
    path: 'reset',
    loadChildren: () => import('./login/login-reset-password/login-reset-password.module').then(m => m.LoginResetPasswordModule)
  },
  {
    path: 'registration',
    loadChildren: () => import('./login/registration/registration.module').then(m => m.OctRegistrationModule)
  },
  {
    path: 'email-change',
    loadComponent: () => import('./login/email-change/email-change.component').then(m => m.EmailChangeComponent)
  },
  {
    path: 'sso',
    component: SsoComponent
  }
];
